// Portions ISC — Lucide Icons (https://lucide.dev/license). Full notice: @air/design-icons LICENSE.
// GENERATED — do not edit. Re-run `pnpm build:icons` or edit scripts/lib/generateIcons.js.
// Source: lucide-react@1.46.0 — SVG path data inlined at codegen.

import { type IconNode } from "../../../internal/iconNode";

export const iconNode = [
  ["rect", { height: "7", rx: "1", width: "7", x: "3", y: "3" }],
  ["rect", { height: "7", rx: "1", width: "7", x: "14", y: "3" }],
  ["rect", { height: "7", rx: "1", width: "7", x: "14", y: "14" }],
  ["rect", { height: "7", rx: "1", width: "7", x: "3", y: "14" }],
] as const satisfies IconNode;
